





































import { TipoDeOperacao } from '@/models/Recurso'
import { montarOperacaoDeRecurso } from '@/shareds/permissoes-shareds'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { SaveCategoriaUseCase } from '@/usecases'
import { Vue, Component, Ref } from 'vue-property-decorator'

@Component
export default class DialogoDeEdicaoDeCategoria extends Vue{
	@Ref() form!: HTMLFormElement
	@Ref() campoDeNome!: HTMLInputElement

	saveUseCase = new SaveCategoriaUseCase()
	categoria = {id: "", nome: ""}
	salvando = false
	mostra = false
	criandoCategoria = false


	mostrar(categoria, criando: boolean){
		this.categoria = JSON.parse(JSON.stringify(categoria))
		this.mostra = true
		this.criandoCategoria = criando
		this.categoria = categoria

		setTimeout(() => {
			this.form.resetValidation()
			this.campoDeNome.focus()
		})
	}

	get podeAlterarMotivo() {
		return this.podeRealizarOperacao('alterar')
	}

	podeRealizarOperacao(operacao: TipoDeOperacao) {
		return !'categoria' || UserLoginStore.temAutorizacao(montarOperacaoDeRecurso(operacao, 'categoria'))
	}

	esconder(){
		this.mostra = false
	}

	async salvar() {
		if (!this.categoria) return
		if (!this.form.validate()) return
		try {
			this.salvando = true
			const categoriaSalva = this.categoria.id
				? await this.saveUseCase.update(this.categoria)
				: await this.saveUseCase.create(this.categoria)

			this.$emit('confirmado', categoriaSalva)
			this.mostra = false
			AlertModule.setSuccess('Categoria salva com sucesso')
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}
}
